import { List } from "office-ui-fabric-react";

export default class Invoice {
  id: number;
  name: string;
  amount_total: number;
  currency_id: List;
  companyId: number;

  static fromJSON(o: Object): Invoice {
    const invoice = new Invoice();
    invoice.id = o["id"];
    invoice.name = o["name"];
    invoice.amount_total = o["amount_total"];
    invoice.currency_id = o["currency_id"];
    invoice.companyId = o["company_id"];
    return invoice;
  }
}
